var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLearnericon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.2686 0.0704637C9.98113 0.135796 7.60304 0.828317 4.97669 1.6123C1.91915 2.52695 0.168246 3.11494 0.076781 3.25867C-0.223747 3.74213 0.142113 3.88586 5.18575 5.40157C9.48461 6.69514 10.2686 6.89114 11.1179 6.90421C11.9934 6.91727 12.5291 6.78661 16.3837 5.63676C18.7487 4.94424 20.7609 4.39545 20.8655 4.43465C20.9569 4.47385 21.2967 5.00957 21.5972 5.61063C22.4465 7.3354 22.6556 7.27007 23.2044 5.12717C23.518 3.91199 23.5441 3.68987 23.3873 3.53307C23.139 3.27174 12.3462 0.0835304 11.4838 0.018198C11.1048 -0.0210013 10.5561 0.00513172 10.2686 0.0704637Z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.42182 6.65424C3.31729 6.77183 3.27809 7.88248 3.30423 10.4043L3.34343 13.9845L6.7407 14.9906C11.2878 16.3365 11.0788 16.3365 15.6259 14.9906L19.0231 13.9845L19.0623 10.2998C19.0885 6.77183 19.0885 6.61504 18.8402 6.53664C18.6965 6.49744 17.2592 6.8633 15.4691 7.41209C11.2225 8.70567 11.1441 8.70567 6.91056 7.41209C5.19886 6.88943 3.74849 6.47131 3.68315 6.47131C3.61782 6.47131 3.50022 6.5497 3.42182 6.65424Z",
    fill: "#303030"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnericon);
export default __webpack_public_path__ + "static/media/learnericon.ad1a68e1059eb320b04986bccc99dec7.svg";
export { ForwardRef as ReactComponent };